import { Part, partProps } from '@/Engine/Wardrobe/Part';
import { defaultBasketOffsets, defaultBasketRotation } from '@/Constants/baskets';

export class Basket extends Part {
    constructor(props: partProps) {
        super({ offsets: [ ...defaultBasketOffsets ], rotation: [ ...defaultBasketRotation ], ...props });
    }
}
